import { PermissionsGate } from 'features/permissions'
import {
  PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN,
  PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR,
  PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER,
} from 'types'

interface DefinedGateProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const InventoryOverviewAdminGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}

export const InventoryOverviewEditorGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[
        PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN,
        PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR,
      ]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}

export const InventoryOverviewViewerGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[
        PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_ADMIN,
        PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_EDITOR,
        PERMISSION_CANTILEVER_INVENTORY_MANAGEMENT_VIEWER,
      ]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}
